import { render, staticRenderFns } from "./review-purchase-item.vue?vue&type=template&id=20b543aa&"
import script from "./review-purchase-item.vue?vue&type=script&lang=js&"
export * from "./review-purchase-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports